import React, { useState } from "react";
import { Menu, X, Search } from "lucide-react";
import { Button } from "./ui/button";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
    setIsMenuOpen(false); // Chiudi il menu mobile dopo il click
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white z-50 border-b-2 border-gray-200 shadow-xl">
      <div className="container mx-auto px-4 lg:px-6">
        <div className="flex items-center justify-between h-36">
          {/* Logo ANCORA PIÙ GIGANTESCO */}
          <div className="flex-shrink-0 py-4">
            <img 
              src="/images/nbz5qg9u_logo_star_italia_web.png"
              alt="Star Italia"
              className="h-32 w-auto object-contain hover:scale-105 transition-transform duration-300"
              style={{ 
                filter: 'contrast(1.2) saturate(1.3) brightness(1.0)',
                maxWidth: '400px'
              }}
            />
          </div>

          {/* Desktop Navigation - MENU GRANDE */}
          <nav className="hidden md:flex space-x-12">
            <button
              onClick={() => scrollToSection('home')}
              className="text-gray-700 hover:text-blue-600 font-semibold text-lg transition-colors duration-200 py-2 px-4"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-blue-600 font-semibold text-lg transition-colors duration-200 py-2 px-4"
            >
              Chi Siamo
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-blue-600 font-semibold text-lg transition-colors duration-200 py-2 px-4"
            >
              Servizi
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-blue-600 font-semibold text-lg transition-colors duration-200 py-2 px-4"
            >
              Contatti
            </button>
          </nav>

          {/* Search e Mobile Menu - PIÙ GRANDI */}
          <div className="flex items-center space-x-6">
            <Button
              variant="ghost"
              size="lg"
              onClick={() => setIsSearchOpen(!isSearchOpen)}
              className="hover:bg-gray-100 p-3"
            >
              <Search className="h-6 w-6" />
            </Button>

            <Button
              variant="ghost"
              size="lg"
              className="md:hidden p-3"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>
        </div>

        {/* Search Bar */}
        {isSearchOpen && (
          <div className="py-4 border-t border-gray-100 animate-in slide-in-from-top-2">
            <div className="relative">
              <input
                type="text"
                placeholder="Cerca..."
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                onKeyDown={(e) => {
                  if (e.key === "Escape") {
                    setIsSearchOpen(false);
                  }
                }}
              />
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
            </div>
          </div>
        )}

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 space-y-4 border-t border-gray-100 animate-in slide-in-from-top-2">
            <button
              onClick={() => scrollToSection('home')}
              className="block text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="block text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200"
            >
              Chi Siamo
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="block text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200"
            >
              Servizi
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200"
            >
              Contatti
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;